import * as Scrivito from "scrivito";
import defaultPageAttributes from "objs/_defaultPageAttributes";
import metadataAttributes from "objs/_metadataAttributes";

const HomepagePresentationSlide = Scrivito.provideObjClass(
  "HomepagePresentationSlide",
  {
    attributes: {
      backgroundImage: ["reference", { only: ["Image"] }],
      imageBottom: ["reference", { only: ["Image"] }],
      imageLeft: ["reference", { only: ["Image"] }],
      sortKey: "integer",
      subtitle: "string",
      targetLink: "link",
      backgroundColorHeadline: ["enum", { values: ["yes", "no"] }],
      ...defaultPageAttributes,
      ...metadataAttributes,
    },
  },
);

export default HomepagePresentationSlide;
